import type { EmailConfigurationDto } from "../../services/ApiService";
import type { EmailConfiguration } from "../../types/EmailConfiguration";

export const toEmailConfiguration = (dto: EmailConfigurationDto): EmailConfiguration => ({
  domain: dto.domain,
  shared: dto.shared,
  fromName: dto.fromName,
  fromEmail: dto.fromEmail,
  isVerified: dto.records.sending.status === "verified" && dto.records.bounce.status === "verified",
  records: {
    sending: dto.records.sending,
    bounce: dto.records.bounce,
  },
});
